import React from 'react';

const ArtworkSkeleton = () => {
  return (
    <div className="w-full mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
      <div className="p-4">
        <div className="flex items-center justify-between mb-1">
          <div className="w-full">
            <div className="flex items-center gap-2 mb-2">
              <div className="h-5 bg-gray-200 rounded animate-pulse w-32"></div>
              <div className="w-4 h-4 bg-gray-200 rounded-full animate-pulse"></div>
            </div>
            <div className="h-4 bg-gray-200 rounded animate-pulse w-24 ml-1"></div>
          </div>
        </div>

        <div className="relative">
          <div className="w-full h-64 bg-gray-200 rounded-lg animate-pulse"></div>
        </div>

        <div className="flex justify-between bg-gray-200 items-center py-4 px-4 rounded-b-lg -mt-2 animate-pulse">
          <div className="flex flex-col items-center">
            <div className="h-4 bg-gray-300 rounded w-8 mb-1"></div>
            <div className="h-3 bg-gray-300 rounded w-16"></div>
          </div>
          <div className="flex flex-col items-center">
            <div className="h-4 bg-gray-300 rounded w-8 mb-1"></div>
            <div className="h-3 bg-gray-300 rounded w-12"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtworkSkeleton;